import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CreateProfessionalJob } from "../../types/createJobSchema";

import { CreateJobResponse } from "../types/job.types";
import { createJobProfessional } from "../services/job.services";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";

export const useCreateProfessionalJob = (options?: { onSuccess?: (data: CreateJobResponse) => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateProfessionalJob) => createJobProfessional(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.jobDetails(data.id) });
      options?.onSuccess?.(data);
    },
    onError: () => {},
  });
};
